import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { ArrowRight } from "lucide-react";

export default function NameNumerology() {
  return (
    <>
      <Seo title="Name Numerology & Name Analysis" path="/name-numerology"
        description="Understand how your name maps to numbers, and how alternative spellings change the calculated values." />
      <PageHeader eyebrow="Name numerology" title="How your name shapes your numbers"
        subtitle="Every letter maps to a number. Our Name Numerology Analysis explains your name numbers and compares alternative spellings — clearly and honestly." />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20 space-y-10">
        <div className="bg-white rounded-2xl border border-border p-8 card-lift">
          <h2 className="font-serif text-3xl text-navy mb-3">What the analysis covers</h2>
          <ul className="grid sm:grid-cols-2 gap-3 text-slate-600 text-sm">
            {["Full-name Expression / Destiny number", "Soul Urge (vowels) and Personality (consonants)",
              "Comparison of alternative spellings", "How each spelling changes the values",
              "Comparison with your birth-date numbers", "Clearly explained interpretations"].map((f) => (
              <li key={f} className="flex gap-2"><span className="text-gold-hover">◆</span>{f}</li>
            ))}
          </ul>
        </div>
        <div className="bg-paper rounded-2xl border border-border p-8">
          <h2 className="font-serif text-3xl text-navy mb-3">Explore the numbers behind your name</h2>
          <p className="text-slate-600 leading-relaxed">
            A small change in spelling can produce a surprisingly different set of numbers. Your
            analysis lays these variations side by side, explores their traditional interpretations,
            and helps you compare the results — so you can see which version of your name resonates
            most with you.
          </p>
        </div>
        <div className="text-center">
          <Link to="/checkout?package=name" className="btn-gold">Analyze my name <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </>
  );
}
